export const HR_TRAINING_COURSE_PERMISSION_CODES = {
    WEB_HR_TRAINING_COURSE_LIST: 'WEB_HR_TRAINING_COURSE_LIST',
    WEB_HR_TRAINING_COURSE_DETAIL: 'WEB_HR_TRAINING_COURSE_DETAIL',
    WEB_HR_TRAINING_COURSE_ADD: 'WEB_HR_TRAINING_COURSE_ADD',
    WEB_HR_TRAINING_COURSE_EDIT: 'WEB_HR_TRAINING_COURSE_EDIT',
    WEB_HR_TRAINING_COURSE_DELETE: 'WEB_HR_TRAINING_COURSE_DELETE',
    WEB_HR_TRAINING_COURSE_IMPORT: 'WEB_HR_TRAINING_COURSE_IMPORT',
    WEB_HR_TRAINING_COURSE_EXPORT: 'WEB_HR_TRAINING_COURSE_EXPORT',
} as const;

